
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

export type PricingFeature = {
  name: string;
  free: string;
  monthly: string;
  yearly: string;
  test?: string;
};

interface PricingFeaturesListProps {
  features: PricingFeature[];
  planType: "free" | "monthly" | "yearly";
}

export default function PricingFeaturesList({ features, planType }: PricingFeaturesListProps) {
  return (
    <ul className="space-y-2 mb-6">
      {features.map((feature, i) => {
        // Select the appropriate feature value based on plan type
        const featureValue = planType === "free" 
          ? feature.free 
          : planType === "monthly" 
            ? feature.monthly 
            : feature.yearly;
            
        return (
          <li key={i} className="flex items-start gap-2">
            <Check 
              className={cn(
                "h-4 w-4 mt-1",
                planType === "free" ? "text-muted-foreground" : "text-primary"
              )} 
            />
            <div>
              <span className="text-sm font-medium">
                {feature.name === "Idea Generation" && planType === "free" 
                  ? "3 Idea Generations one-time"
                  : feature.name === "Idea Generation" && planType !== "free" 
                    ? "30 Idea Generations monthly" 
                    : feature.name}
              </span>
              {featureValue && (
                <p className="text-xs text-muted-foreground">{featureValue}</p>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
